<template>
  <div class="invoice-header-info px-i d-none d-md-block">
    <div class="invoice-header-info-row container-fluid p-0">
      <div class="invoice-title">
        {{ invoiceNumber }} - {{ invoiceSubject }}
      </div>
      <div class="invoice-details-row pb-4">
        <div class="invoice-details-row-cell">
          <p class="invoice-details-row-cell-title">
            {{ invoiceVoucherType.toUpperCase() }} NUMBER
          </p>
          <p>{{ invoiceNumber }}</p>
        </div>
        <div class="invoice-details-row-cell">
          <p class="invoice-details-row-cell-title">
            DATE
          </p>
          <p>{{ invoiceDate | formatDateInNumeric(true) }}</p>
        </div>
        <div v-if="invoiceDueDate" class="invoice-details-row-cell">
          <p class="invoice-details-row-cell-title">
            DUE DATE
          </p>
          <p>{{ invoiceDueDate | formatDateInNumeric(true) }}</p>
        </div>
        <div v-if="customerName" class="invoice-details-row-cell">
          <p class="invoice-details-row-cell-title">
            CUSTOMER
          </p>
          <p>{{ customerName }}</p>
        </div>
        <div class="invoice-details-row-cell">
          <p class="invoice-details-row-cell-title">
            AMOUNT
          </p>
          <p>{{ invoiceAmount | formatCurrency(currencyIsoCode, currencyMinimumDigits) }}</p>
        </div>
        <div class="invoice-details-row-cell">
          <p class="invoice-details-row-cell-title">
            STATUS
          </p>
          <div class="status-indicator status-indicator-rectangular" :class="pillColorClass">
            {{ invoiceStatus }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InvoiceHeader",

  props: {
    invoiceNumber: { type: String },
    invoiceSubject: { type: String },
    invoiceDate: { type: [String, Date] },
    invoiceDueDate: { type: [String, Date] },
    customerName: { type: String },
    invoiceAmount: { type: [Number, String] },
    currencyIsoCode: { type: String },
    invoiceStatus: { type: String },
    pillColorClass: { type: String },
    invoiceVoucherType: { type: String }
  },

  computed: {
    currencyMinimumDigits () {
      return this.currencyIsoCode === "LBP" ? 0 : 2;
    }
  }
};
</script>
